
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";

interface InvitationCodeSectionProps {
  invitationCode: string;
  setInvitationCode: (code: string) => void;
  handleRedeemCode: () => void;
  redeemingCode: boolean;
}

export const InvitationCodeSection = ({
  invitationCode,
  setInvitationCode,
  handleRedeemCode,
  redeemingCode,
}: InvitationCodeSectionProps) => {
  return (
    <div className="mt-16 max-w-md mx-auto">
      <Separator className="my-8" />
      <div className="text-center mb-8">
        <h2 className="text-xl font-semibold mb-2">Have an Invitation Code?</h2>
        <p className="text-sm text-gray-600">
          Enter your invitation code below to activate your account
        </p>
      </div>
      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="invitationCode">Invitation Code</Label>
          <Input
            id="invitationCode"
            placeholder="Enter your invitation code"
            value={invitationCode}
            onChange={(e) => setInvitationCode(e.target.value)}
          />
        </div>
        <Button
          className="w-full"
          onClick={handleRedeemCode}
          disabled={redeemingCode || !invitationCode.trim()}
        >
          {redeemingCode ? "Redeeming..." : "Redeem Code"}
        </Button>
      </div>
    </div>
  );
};
